import { render, staticRenderFns } from "./CryptoPayment.vue?vue&type=template&id=4f11aa18&"
import script from "./CryptoPayment.vue?vue&type=script&lang=js&"
export * from "./CryptoPayment.vue?vue&type=script&lang=js&"
import style0 from "./CryptoPayment.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports